module.exports = __webpack_public_path__ + "static/logo-a1d5f8c544633880d8e6a71128802d63.svg";